import { render, staticRenderFns } from "./CreatePQButton.vue?vue&type=template&id=36d5e911&scoped=true&"
import script from "./CreatePQButton.vue?vue&type=script&lang=js&"
export * from "./CreatePQButton.vue?vue&type=script&lang=js&"
import style0 from "./CreatePQButton.vue?vue&type=style&index=0&id=36d5e911&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d5e911",
  null
  
)

export default component.exports